/**
 * ProfileVideoPlayer
 *
 * Thin owner wrapper over the shared NativeVideoPlayer: binds the always-signed
 * token fetch to /api/profiles/:userId/videos/:videoId/playback-token. All the
 * playback/retry/remount logic lives in NativeVideoPlayer.
 */

import { useCallback } from "react"
import { NativeVideoPlayer } from "@/components/media/NativeVideoPlayer"
import {
  getProfileVideoPlaybackToken,
  type ProfileVideoItem,
} from "../services/profileVideo.service"

export interface ProfileVideoPlayerProps {
  userId: string
  video: ProfileVideoItem
  className?: string
}

export function ProfileVideoPlayer({ userId, video, className }: ProfileVideoPlayerProps) {
  const fetchToken = useCallback(
    () => getProfileVideoPlaybackToken(userId, video.id),
    [userId, video.id],
  )
  return (
    <NativeVideoPlayer
      status={video.status}
      cloudflareUid={video.cloudflareUid}
      failureReason={video.failureReason}
      fetchToken={fetchToken}
      className={className}
    />
  )
}
